import { Component, Inject, OnDestroy } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { TranslateService } from '@ngx-translate/core'
import { UserService } from 'src/app/providers/service/user.service'

@Component({
    selector: 'app-two-fa-code-dialog',
    templateUrl: './two-fa-code-dialog.component.html',
    styleUrls: ['./two-fa-code-dialog.component.scss'],
    standalone: false
})
export class TwoFaCodeDialogComponent implements OnDestroy {
  code = ''
  isSubmitting = false
  errorMessage = ''
  canResend = true
  resendCountdown = 0
  private countdownInterval: any
  private readonly RESEND_COOLDOWN = 60

  constructor(
    public dialogRef: MatDialogRef<TwoFaCodeDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string
      onSubmit: (code: string) => Promise<void>
      onResendSms: () => Promise<void>
    },
    private userService: UserService,
    private translate: TranslateService
  ) {}

  ngOnDestroy() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval)
    }
  }

  isValidCode(): boolean {
    return /^\d{6}$/.test(this.code)
  }

  async submit() {
    if (!this.isValidCode()) return
    await this.data.onSubmit(this.code)
  }

  async resendSms() {
    this.canResend = false
    try {
      await this.userService.web_sendSmsOTP()
      this.startResendCooldown()
    } catch (error) {
      this.errorMessage = this.translate.instant('two_fa.sms_confirmation.error')
      this.canResend = true
    }
  }

  private startResendCooldown() {
    this.resendCountdown = this.RESEND_COOLDOWN
    this.countdownInterval = setInterval(() => {
      this.resendCountdown--
      if (this.resendCountdown <= 0) {
        clearInterval(this.countdownInterval)
        this.canResend = true
      }
    }, 1000)
  }

  get countdownFormatted(): string {
    const minutes = Math.floor(this.resendCountdown / 60)
    const seconds = this.resendCountdown % 60
    return `${minutes}:${seconds.toString().padStart(2, '0')}`
  }
}
